module.exports = __webpack_public_path__ + "static/logo-d6392eb3b524a5fa40418ac9ce6cc3ea.gif";